// import Vue from 'vue'
// import vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Vue.use(vuex);
import app from './modules/app'
import settings from './modules/settings'
import menu from './modules/menu'
import tabsbar from './modules/tabsbar'
import process from './modules/process'
import system from './modules/system'
import user from './modules/user'
import color from './modules/color'

import maint from './modules/maint'
import financial from './modules/financial'
const store = new Vuex.Store({
  modules: {
    app: app,
    settings: settings,
    menu: menu,
    tabsbar: tabsbar,
    process: process,
    system: system,
    user: user,
    color: color,

    maint: maint,
    financial: financial,
  },
  plugins: [createPersistedState({
    reducer(val) {
      return {
        tabsbar: val.tabsbar,
        settings: val.settings
      }
    }
  })]
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js